var React = require('react');

function GreenEdit (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#12DFC7","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M22 12c0 5.515-4.468 10-10.012 10C6.468 22 2 17.515 2 12S6.467 2 11.988 2C17.532 2 22 6.485 22 12z","key":0}),React.createElement("path",{"d":"M10.537 16.166 18 8.705 15.295 6l-7.462 7.462L7 17l3.537-.834zm-2.704-2.704 2.704 2.704","key":1})]));
}

GreenEdit.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = GreenEdit;

GreenEdit.default = GreenEdit;
